import moment, { Duration } from 'moment';

import { SbpInvoiceAPIModelStatusEnum } from '@/generated/api/fps/core';
import { createReducerTypeSafe } from '@/utils/redux';

import {
  StoreInitActionPayload,
  storeInitialized,
  storeInvoice,
  StoreInvoiceActionPayload,
  storeLogout,
  storeStatus,
} from './actions';
import { initialState, InvoiceDetails, InvoiceProcessingStatus, State } from './types';

const calculateDuration = (details?: InvoiceDetails): Duration | undefined =>
  details
    ? moment.duration({
        from: details.createdAt,
        to: details.expiresAt,
      })
    : undefined;

const calculateStatus = (details?: InvoiceDetails): InvoiceProcessingStatus | undefined => {
  if (details?.status === SbpInvoiceAPIModelStatusEnum.Succeeded) {
    return InvoiceProcessingStatus.SUCCEEDED;
  }
  // prettier-ignore
  // prettier: FIXME: https://github.com/prettier/prettier/pull/7111
  if (details?.status === SbpInvoiceAPIModelStatusEnum.Unknown
    || details?.status === SbpInvoiceAPIModelStatusEnum.Cancelled
  ) {
    return InvoiceProcessingStatus.FAILED;
  }
  if (details?.expiresAt && moment(details?.expiresAt).isBefore()) {
    return InvoiceProcessingStatus.EXPIRED;
  }
  return InvoiceProcessingStatus.IN_PROGRESS;
};

export const reducers = createReducerTypeSafe<State>(initialState, [
  [
    storeStatus,
    (state: State): State => {
      const processingStatus = calculateStatus(state.details?.value);
      return processingStatus !== state.processingStatus ? { ...state, processingStatus } : state;
    },
  ],
  [
    storeInvoice,
    (state: State, { details, error }: StoreInvoiceActionPayload): State => ({
      ...state,
      details: { value: details, error },
      validPeriod: calculateDuration(details),
      processingStatus: calculateStatus(details),
    }),
  ],
  [
    storeInitialized,
    (state: State, { banks, details, limits }: StoreInitActionPayload): State => ({
      ...state,
      initialized: true,
      banks: banks || [],
      details: { value: details },
      limits,
      validPeriod: calculateDuration(details),
      processingStatus: calculateStatus(details),
    }),
  ],
  [
    storeLogout,
    (): State => ({
      initialized: true,
      banks: [],
    }),
  ],
]);

export default reducers;
